import { RootState } from '../../../redux/store';

export const selectGratuityPanel = (state: RootState) => state.location.gratuityPanel;
